import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { userAddKeycloakDto } from 'src/app/models/userAddKeycloakDto';
import { AuthService } from 'src/app/services/auth/auth.service';
import { collabService } from 'src/app/services/collab/collabService.service';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-page-profil',
  templateUrl: './page-profil.component.html',
  styleUrls: ['./page-profil.component.scss']
})
export class PageProfilComponent implements OnInit {

  value!: string;
  tel!: string;
  stateOptions: any[] = [{ label: 'Admin', state: 'admin' }, { label: 'Vendeur interne', state: 'int' }, { label: 'Vendeur externe', state: 'ext' }];

  state!: string;
  userid!: string;
  userdto!: userAddKeycloakDto;
  email!: string | undefined;
  libelleEntite!: string;
  numEntite!: number;
  gsm!: string;
  prenom!: string;
  nom!: string;
  emailaffiche!: string;

  constructor(private readonly keycloakservice: KeycloakService, private readonly mesg: MessageService, 
    private readonly entiteser: EntitebackService ,private readonly collab: collabService,private readonly  authService: AuthService,private readonly share: shareOpeSevices) {
  }

  ngOnInit(): void {

    this.tel = "";
    this.state = 'int';
    
    
    this.share.userProfilshared$.subscribe(data => {
      if (data !== null && data !== undefined && data.mail !== undefined) {
        this.email = data.mail;
      }
    });
    if (this.email !== undefined) {
      //this.collab.getUserKeycloak(this.email).subscribe((data) => {
      //  this.userdto = data;
      //  this.userid =data.id
      //});
    };

    this.email = this.keycloakservice.getUsername();

    

    this.collab.getCollabByEmail(this.email).subscribe(data=>{

     this.numEntite = parseInt(data.numEntite);
     this.nom = data.nom;
     this.prenom = data.prenom;
     this.emailaffiche = data.email;
     this.gsm = data.telgsm;
     this.share.userProfilshared$.subscribe(data=>{
      this.value=(data.role.includes("admin")) ? "admin" : (data.role.includes("interne") ? "int" : "ext");
     })
    });

      if(this.numEntite !== undefined){
    this.entiteser.getEntitebyId(this.numEntite).subscribe(data=>{

      this.libelleEntite= data.libelle;

    })
  }

  }

 
  resetPassword() {
    // this.collab.restPasswordKeycloak(this.userid).subscribe(data=>{
    //   if(data===1){

    //     this.mesg.add({ severity: 'success', detail: "Vous allez être déconnecter..." });
    //     this.authService.logout();
    //   }
    //  else {
    
    //   this.mesg.add({ severity: 'warn', detail: "Erreur de redirécation !" });
      
    // }
    // });
    //this.authService.logout();
    //this.collab.restPasswordKeycloak(this.userid).subscribe(data=>{
    //    if(data===1){
  
    //      this.mesg.add({ severity: 'success', detail: "Vous allez être déconnecter..." });
    //    }
    //   else {
      
    //    this.mesg.add({ severity: 'warn', detail: "Erreur de redirécation !" });
        
    //  }
    //  });
  }
}
